'use client';

import Link from 'next/link';
import { Package } from 'lucide-react';
import { Button, type buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { VariantProps } from 'class-variance-authority';

type OrdersButtonProps = {
  storeId: string;
  locale: string;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  className?: string;
};

export function OrdersButton({ storeId, locale, variant = 'ghost', className }: OrdersButtonProps) {
  return (
    <Button variant={variant} size="icon" className={cn(className)} asChild>
      <Link href={`/${locale}/${storeId}/orders`} aria-label="My Orders">
        <Package className="h-[1.2rem] w-[1.2rem]" />
      </Link>
    </Button>
  );
}

